import React from "react";

export default function SQL_DISTINCT() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">SQL_DISTINCT</h1>
      <p>This is the SQL_DISTINCT component generated from the SQL JSON.</p>
    </div>
  );
}
